module.exports = __webpack_public_path__ + "static/media/search.687a5c55.svg";